<template>
  <v-container class="pa-4" style="max-width: 800px;">
    <!-- {{ form }} -->
    <div v-if="!setupWizard">
      <v-card v-if="!testNextLetter" elevation="2">
        <v-card-title>Submit Lead to RingCentral</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="submitForm">
            <v-row>
              <v-col cols="6">
                <v-text-field v-model="form.Provider" label="Provider" required></v-text-field>
                <v-text-field v-model="form.CompanyID" label="Company ID" required></v-text-field>
                <v-text-field v-model="form.PortalID" label="Portal ID" required></v-text-field>
                <v-text-field v-model="form.CustomerName" label="Customer Name" required></v-text-field>
                <v-text-field v-model="form.EMail" label="Email" type="email"></v-text-field>
                <v-text-field v-model="form.Phones" label="Phones" required></v-text-field>
                <v-text-field v-model="form.JobDate" label="Job Date" required></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="form.OrigCity" label="Origin City" required></v-text-field>
                <v-text-field v-model="form.OrigState" label="Origin State" required></v-text-field>
                <v-text-field v-model="form.OrigZip" label="Origin Zip" required></v-text-field>
                <v-text-field v-model="form.DestCity" label="Destination City" required></v-text-field>
                <v-text-field v-model="form.DestState" label="Destination State" required></v-text-field>
                <v-text-field v-model="form.DestZip" label="Destination Zip" required></v-text-field>
                <v-text-field v-model="form.EstimatedLbs" label="Estimated Lbs" required></v-text-field>
              </v-col>
            </v-row>
            <v-textarea v-model="form.Details" label="Details" rows="3"></v-textarea>
            <v-btn type="submit" color="primary" :loading="loading" block>
              Submit Lead
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
      <v-card v-else>
        <v-text-field v-model="letter_id"></v-text-field>
        <v-btn @click="testLetter()">Test Next Letter</v-btn>
        <div v-html="letterBody"></div>
      </v-card>
    </div>
    <v-setup-wizard v-else></v-setup-wizard>
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" top>
      {{ snackbar.text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import * as fun from "../plugins/common";
export default {
  data() {
    return {
      form: {
        Provider: "Movers",
        CompanyID: "101",
        PortalID: "359",
        CustomerName: "John Customer",
        EMail: "yy@gmail.com",
        Phones: "212-555-5554",
        JobDate: "5/30/2025",
        OrigCity: "Brooklyn",
        OrigState: "NY",
        OrigZip: "10001",
        DestCity: "New York",
        DestState: "NY",
        DestZip: "11201",
        EstimatedLbs: "1000",
        Details: "This is a test"
      },
      loading: false,
      snackbar: {
        show: false,
        text: "",
        color: ""
      },
      testNextLetter: false,
      setupWizard: true,
      letter_id: "3c53ef92005f9e2a4d256c70",
      letterBody: ""
    };
  },
  components: {
    VDocument: () => import("../components/Document.vue"),
    VSetupWizard: () => import("../components/SetupWizard.vue")
  },
  methods: {
    async testLetter() {
      this.loading = true;
      try {
        const response = await axios.post(this.serverURL + "/get_next_letter", {
          letter_id: this.letter_id,
          portal_id: 85
        });
        this.letterBody = response.data.message;
      } catch (error) {
        this.snackbar.text = error.response?.data?.message || "Failed to test letter.";
        this.snackbar.color = "red";
      } finally {
        this.snackbar.show = true;
        this.loading = false;
      }
    },
    submitForm() {
      this.loading = true;
      try {
        axios
          .post(this.serverURL + "/submit_lead", this.form, {
            withCredentials: true
          })
          .then(response => {
            this.snackbar.text = response.data.message || "Lead submitted successfully.";
            this.snackbar.color = "green";
          });
      } catch (error) {
        this.snackbar.text = error.response?.data?.message || "Failed to submit lead.";
        this.snackbar.color = "red";
      } finally {
        this.snackbar.show = true;
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.v-card {
  border-radius: 12px;
}
</style>
